import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';

import IconComponent from '../../../../common/components/IconComponent';
import useServiceConnectionMetadataByName from '../../../ServiceConnections/Hooks/useServiceConnectionMetadataByName';
import { ServiceConnectionRefModel } from '../../Models/ServiceConnectionModel';
import { IconServiceConnection } from '../Icons';
import ServiceConnectionPicker from './ServiceConnectionPicker';

type ServiceConnectionInputDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	serviceConnectionType: string | undefined;
	serviceConnectionCategory?: string | undefined;
	value: ServiceConnectionRefModel | undefined;
	onValueChange: (value: ServiceConnectionRefModel | undefined) => void;
};

export default function ServiceConnectionInputDialog({
	open,
	setOpen,
	value,
	onValueChange,
	serviceConnectionType,
	serviceConnectionCategory,
}: ServiceConnectionInputDialogProps) {
	const serviceConnectionMetadata = useServiceConnectionMetadataByName(serviceConnectionType);
	const handleClose = () => setOpen(false);

	return (
		<Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
			<DialogTitle>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					{serviceConnectionMetadata?.iconUrl || serviceConnectionMetadata?.iconName ? (
						<IconComponent iconUrl={serviceConnectionMetadata.iconUrl} iconName={serviceConnectionMetadata.iconName} />
					) : (
						<IconServiceConnection />
					)}
					Service Connection
				</Box>
			</DialogTitle>
			<DialogContent dividers>
				{open && (
					<ServiceConnectionPicker
						serviceConnectionType={serviceConnectionType}
						serviceConnectionCategory={serviceConnectionCategory}
						value={value}
						onSave={(connection) => {
							onValueChange(connection);
							return true;
						}}
						onCancel={handleClose}
					/>
				)}
			</DialogContent>
		</Dialog>
	);
}
